import { useMemo } from 'react';

interface MessageCardProps {
  message: string;
  uploaderName: string;
  style?: React.CSSProperties;
  className?: string;
}

export default function MessageCard({ 
  message, 
  uploaderName,
  style, 
  className = '' 
}: MessageCardProps) {
  // Random rotation between -5 and 5 degrees
  const rotation = useMemo(() => Math.random() * 10 - 5, []);

  return (
    <div
      className={`polaroid cursor-default transform transition-all duration-300 ${className}`}
      style={{
        ...style,
        transform: `rotate(${rotation}deg)`,
      }}
    >
      <div className="p-4 min-h-[120px] flex flex-col justify-center">
        <p className="font-body text-autumn-brown italic text-center leading-relaxed text-sm md:text-base">
          "{message}"
        </p>
      </div>
      
      {/* Bottom section with name */}
      <div className="pt-2 pb-1 text-center border-t border-autumn-gold/10">
        <p className="font-display text-sm text-autumn-light-brown">
          — {uploaderName}
        </p>
      </div>
    </div>
  );
}

